import { escapeHTML } from "../../render/ui-helpers.js";

export function renderHarnessAgentModeSection(pageState, options = {}) {
  return `
    <div class="field">
      <label for="agent-model">Model</label>
      <input id="agent-model" name="model" placeholder="gpt-5-nano" value="${escapeHTML(pageState.agentDraft.model)}">
    </div>
    <div class="form-grid form-grid--split">
      <div class="field">
        <label for="agent-adapter">Adapter</label>
        <select id="agent-adapter" name="adapter_id">
          <option value="opencode.server" ${pageState.agentDraft.adapter_id === "opencode.server" ? "selected" : ""}>opencode.server</option>
          <option value="noop" ${pageState.agentDraft.adapter_id === "noop" ? "selected" : ""}>noop</option>
        </select>
      </div>
      <div class="field">
        <label for="agent-harness">Harness</label>
        ${pageState.agentDraft.adapter_id === "opencode.server" ? `
          ${pageState.hasHarnessChoice ? `
            <select id="agent-harness" name="harness_id" ${pageState.availableHarnesses.length ? "" : "disabled"}>
              ${pageState.availableHarnesses.length
                ? pageState.availableHarnesses.map((item) => `<option value="${escapeHTML(item.id)}" ${pageState.agentDraft.harness_id === item.id ? "selected" : ""}>${escapeHTML(options.harnessDisplayLabel?.(item) || item.id)}</option>`).join("")
                : `<option value="">No harnesses</option>`}
            </select>
          ` : `<input value="${escapeHTML(pageState.selectedHarness ? options.harnessDisplayLabel?.(pageState.selectedHarness) || pageState.selectedHarness.id : "Built-in OpenCode")}" disabled>`}
        ` : `<input value="Built-in runtime" disabled>`}
      </div>
    </div>
    ${pageState.selectedHarness ? `<div class="form-note">${escapeHTML(options.formatHarnessNote?.(pageState.selectedHarness) || pageState.selectedHarness.id)}</div>` : ""}
    ${pageState.staleServerURL ? `<div class="form-note form-note--warn">Stale server_url: ${escapeHTML(pageState.staleServerURL)}</div>` : ""}
  `;
}
